import { render } from "./EditVideo.vue?vue&type=template&id=11478e74"
import script from "./EditVideo.vue?vue&type=script&lang=js"
export * from "./EditVideo.vue?vue&type=script&lang=js"

import "./EditVideo.vue?vue&type=style&index=0&id=11478e74&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__